import React from 'react';
import { render } from 'react-dom';
import Tabs from '~c/ui/Tabs';
import ProfilesTab from './ProfileTab';
import OrderedCoursesTab from './OrderedCoursesTab';
import ChangePassTab from './ChangePassTab';
import ISpringTab, { ISpringHeader, ISpringPopup } from './ISpringTab';
import SmsVerification from '../../components/popups/SmsVerification';
import { ErrorBoundary } from '../../components/popups/ErrorSender';

class ProfilePage extends React.Component {
  pages = {
    education: 'education',
    orders: 'orders',
  };

  tabItems = [
    { header: 'Профили', content: <ProfilesTab /> },
    {
      header: 'Мои заказы',
      content: <OrderedCoursesTab />,
      page: this.pages.orders,
    },
    { header: 'Изменение пароля', content: <ChangePassTab /> },
    {
      header: (
        <React.Fragment>
          <div className="tab-exit" />
          Выход
        </React.Fragment>
      ),
      content: null,
      headerStyle: { marginLeft: 30 },
      onClick: () => {
        window.location.assign('/?logout=yes');
      },
    },
  ];

  constructor(props) {
    super(props);
    const isISpringShown = this.checkISpringData();
    const isBadgeShownDate = localStorage.getItem('iSpringFeatureViewedDate');
    // two weeks
    const badgeTimeout = 14 * 24 * 60 * 60 * 1000;
    const withBadge = isBadgeShownDate
      ? Date.now() - badgeTimeout < isBadgeShownDate
      : true;

    if (isISpringShown) {
      const { tabItems } = this;
      const iSpringItem = {
        header: <ISpringHeader withBadge={withBadge} />,
        content: <ISpringTab />,
        headerStyle: { marginLeft: withBadge ? 41 : 0 },
        page: this.pages.education,
      };
      const ordersIndex = this.tabItems?.findIndex(
        item => item.header === 'Мои заказы',
      );
      tabItems.splice(ordersIndex + 1, 0, iSpringItem);
    }
  }

  checkISpringData = () => {
    const iSpringCourses = window.user?.ISPRING_REGISTRATION_FORMS || [];
    return iSpringCourses?.length > 0;
  };

  getSelectedTabId = () => {
    const pageRegExp = new RegExp(/[&?]page=([\w-]+)/);
    const pageResult = window.location.search.match(pageRegExp);
    if (!pageResult) {
      return 0;
    }
    const pageName = pageResult[1];
    const index = this.tabItems.findIndex(item => item.page === pageName);
    return index < 0 ? 0 : index;
  };

  componentDidMount() {
    const isISpringPopupHidden = localStorage.getItem('isISpringPopupHidden');

    if (this.checkISpringData() && !isISpringPopupHidden) {
      $.magnificPopup.open({
        removalDelay: 250,
        mainClass: 'mfp-anim',
        closeOnBgClick: false,
        items: {
          src: $('#popup'),
          type: 'inline',
        },
        callbacks: {
          open: () => {
            render(<ISpringPopup />, $('#popup')[0]);
          },
          close() {
            const isBadgeShownDate = localStorage.getItem(
              'iSpringFeatureViewedDate',
            );
            if (!isBadgeShownDate) {
              localStorage.setItem('iSpringFeatureViewedDate', Date.now());
            }
            localStorage.setItem('isISpringPopupHidden', true);
            render(<div />, $('#popup')[0]);
          },
        },
      });
    }
  }

  render() {
    const { tabItems } = this;
    return (
        <Tabs items={tabItems} selectedTabId={this.getSelectedTabId()} />
    );
  }
}

export default ProfilePage;
